import { getCurrentSeason, getMapPoolForSeason } from '../../data/seasons';

export const MODES = ['HP', 'SND', 'CTL'];

// Get current season's map pools (defaults to current season for new entries)
const currentSeason = getCurrentSeason();
export const mapPools = {
  HP: getMapPoolForSeason(currentSeason, 'HP'),
  SND: getMapPoolForSeason(currentSeason, 'SND'),
  CTL: getMapPoolForSeason(currentSeason, 'CTL')
};

